import React, { createContext } from 'react'
import { useReducer } from 'react'
import { ClerkProvider } from '@clerk/clerk-react'
import { reducer } from '../reducer/reducer'
import { dark } from '@clerk/themes'

export let USER_CONTEXT = createContext({})
let defaultContext = {
  tasks: [],
  groups: ['University', 'Course', 'Community', 'Company', 'Organization'],
  selectedGroup: 'University',
  notifications: [],
}

if (!process.env.REACT_APP_CLERK_PUBLISHABLE_KEY) {
  throw new Error('Missing Publishable Key')
}
const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY

const ContextProvider = ({ children }) => {
  let [state, dispatch] = useReducer(reducer, defaultContext)

  return (
    <div>
      <USER_CONTEXT.Provider value={{ data: state, setData: dispatch }}>
        <ClerkProvider
          publishableKey={clerkPubKey}
          appearance={{
            baseTheme: dark,
          }}
        >
          {children}
        </ClerkProvider>
      </USER_CONTEXT.Provider>
    </div>
  )
}

export default ContextProvider
